import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { WorkQueueModel } from '../../../shared/models/business-transaction/work-queue.model';

@Component({
    selector: 'my-escalations',
    templateUrl: './my-escalations.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyEscalationsComponent implements OnInit {
    @Input() csrOverridesQueue: WorkQueueModel[];

    constructor() {}

    ngOnInit() {}

    public myEscalationsCols = [
        { field: 'agentName', header: 'Agent' },
        { field: 'customerName', header: 'Customer Name' },
        { field: 'transactionType', header: 'Service' },
        { field: 'escalationType', header: 'Reason' },
        { field: 'displayUpdatedDate', header: 'Date/Time' },
        { field: 'assignedTo', header: 'Assigned To' },
    ];
}
